module.exports = __webpack_public_path__ + "img/winterdienst.7ba95a4a.svg";